import { Header } from './Header'

interface MainLayoutProps {
  sidebar: React.ReactNode
  children: React.ReactNode
  currentView: 'dashboard' | 'users' | 'clients' | 'settings'
  setCurrentView: (view: 'dashboard' | 'users' | 'clients' | 'settings') => void
}

export function MainLayout({ sidebar, children, currentView, setCurrentView }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-slate-950">
      <div className="mx-auto max-w-[1320px] px-4 py-4">
        <Header currentView={currentView} setCurrentView={setCurrentView} />

        <div
          className={
            currentView === 'dashboard'
              ? 'mt-4 grid grid-cols-1 gap-4 lg:grid-cols-[300px_minmax(0,1fr)]'
              : 'mt-4 grid grid-cols-1'
          }
        >
          {currentView === 'dashboard' && <aside className="min-w-0">{sidebar}</aside>}
          <main className="min-w-0">{children}</main>
        </div>
      </div>
    </div>
  )
}
